import { HHTextField } from '@hinge-health/react-component-library';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

// Wizard state holds dates as ISO 'YYYY-MM-DD' strings. ContractDecision uses
// `string | null`; CspRow uses `string | undefined`. Treat empty string,
// null, and undefined uniformly as "no date" so the picker can drive both
// shapes.
const ISO_FORMAT = 'YYYY-MM-DD';

const isoToDayjs = (value: string | null | undefined): Dayjs | null => {
  if (value == null || value === '') return null;
  const d = dayjs(value, ISO_FORMAT, true);
  return d.isValid() ? d : null;
};

const dayjsToIso = (d: Dayjs | null): string | null => {
  if (d == null || !d.isValid()) return null;
  return d.format(ISO_FORMAT);
};

export interface IsoDateFieldProps {
  label: string;
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  helperText?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  minDate?: string | null;
  maxDate?: string | null;
}

export const IsoDateField = ({
  label,
  value,
  onChange,
  disabled,
  helperText,
  size,
  fullWidth,
  minDate,
  maxDate,
}: IsoDateFieldProps): JSX.Element => (
  <DatePicker
    label={label}
    value={isoToDayjs(value)}
    disabled={disabled}
    inputFormat={ISO_FORMAT}
    minDate={minDate != null ? (isoToDayjs(minDate) ?? undefined) : undefined}
    maxDate={maxDate != null ? (isoToDayjs(maxDate) ?? undefined) : undefined}
    onChange={(d): void => onChange(dayjsToIso(d))}
    renderInput={(params): JSX.Element => (
      <HHTextField
        {...params}
        hhVariant="variant-bypass"
        size={size}
        fullWidth={fullWidth}
        helperText={helperText ?? params.helperText}
      />
    )}
  />
);
